import React from "react";

const PhpLogo = () => {
    return (
        <svg width="512" height="512" x="0" y="0" viewBox="0 0 512 512">
            <g>
                <path
                    fill="#ddeafb"
                    d="M5.127 141.341 0 150.576V417.56c0 17.618 14.282 31.9 31.9 31.9h448.2c17.618 0 31.9-14.282 31.9-31.9V150.576l-5.127-9.235z"
                    opacity="1"
                ></path>
                <path
                    fill="#cbe2ff"
                    d="M459.765 141.341v223.983c0 17.618-14.282 31.9-31.9 31.9H0v20.335c0 17.618 14.282 31.9 31.9 31.9h448.2c17.618 0 31.9-14.282 31.9-31.9V150.576l-5.127-9.235z"
                    opacity="1"
                ></path>
                <path
                    fill="#698ed5"
                    d="M480.1 62.54H31.9C14.282 62.54 0 76.822 0 94.44v56.136h512V94.44c0-17.618-14.282-31.9-31.9-31.9z"
                    opacity="1"
                ></path>
                <path
                    fill="#4073c8"
                    d="M480.1 62.54h-20.335v88.036H512V94.44c0-17.618-14.282-31.9-31.9-31.9z"
                    opacity="1"
                ></path>
                <circle
                    cx="57.783"
                    cy="106.558"
                    r="14.312"
                    fill="#dd636e"
                    opacity="1"
                ></circle>
                <circle
                    cx="101.809"
                    cy="106.558"
                    r="14.312"
                    fill="#ffe07d"
                    opacity="1"
                ></circle>
                <circle
                    cx="145.835"
                    cy="106.558"
                    r="14.312"
                    fill="#86f1a7"
                    opacity="1"
                ></circle>
                <path
                    fill="#595454"
                    d="M89.146 343.682a7.713 7.713 0 0 1-5.96-2.804l-46.497-56.26a7.727 7.727 0 0 1 0-9.845l46.497-56.26a7.726 7.726 0 0 1 10.878-1.033 7.726 7.726 0 0 1 1.033 10.878l-42.43 51.337 42.43 51.337a7.727 7.727 0 0 1-5.951 12.65zM426.463 343.682a7.727 7.727 0 0 1-5.952-12.649l42.43-51.337-42.43-51.337a7.727 7.727 0 0 1 11.911-9.845l46.497 56.26a7.727 7.727 0 0 1 0 9.845l-46.497 56.26a7.714 7.714 0 0 1-5.959 2.803z"
                    opacity="1"
                ></path>
                <g fill="#595454">
                    <path
                        d="M288.737 333.43a7.725 7.725 0 0 0 7.726-7.726v-91.353a7.726 7.726 0 1 0-15.452 0v36.383h-47.766v-36.383a7.726 7.726 0 1 0-15.452 0v91.353a7.726 7.726 0 1 0 15.452 0v-39.517h47.766v39.517a7.725 7.725 0 0 0 7.726 7.726zM142.827 325.704v-31.997c5.86-.032 13.664-.07 17.71-.07 18.754 0 34.011-15.031 34.011-33.506s-15.258-33.506-34.011-33.506H135.1c-4.152-.082-7.799 3.581-7.726 7.726v91.353c0 4.268 3.459 7.726 7.726 7.726s7.727-3.458 7.727-7.726zm17.71-83.627c10.059 0 18.558 8.268 18.558 18.053 0 9.786-8.499 18.053-18.558 18.053a4123 4123 0 0 0-17.576.069c-.032-6.016-.093-29.914-.111-36.176h17.687zM330.897 232.113a8.263 8.263 0 0 0-.332 2.238v91.353a7.726 7.726 0 1 0 15.452 0v-31.997c5.86-.032 13.664-.07 17.71-.07 18.754 0 34.011-15.031 34.011-33.506s-15.258-33.506-34.011-33.506H338.29c-3.329-.041-6.464 2.292-7.393 5.488zm32.831 9.964c10.059 0 18.558 8.268 18.558 18.053 0 9.786-8.499 18.053-18.558 18.053a4123 4123 0 0 0-17.576.069c-.032-6.016-.093-29.914-.111-36.176h17.687z"
                        fill="#595454"
                        opacity="1"
                    ></path>
                </g>
            </g>
        </svg>
    );
};

export default PhpLogo;
